<template>
  <v-layout wrap justify-center algin-center>


    <v-flex xs12>
      <v-switch :disabled="lock || cronEvents.length === 0" v-model="cronActive" :label="cronActive ? 'Activado' : 'Desactivado'"></v-switch>
    </v-flex>
    <v-flex xs12>
      <v-alert type="info" color="primary" :value="true">
        Si se activa esta opción, las horas bloqueadas en la <b>vista actual</b> serán repetidas automáticamente cada
        semana.
      </v-alert>
    </v-flex>
    <template>
      <v-flex xs12 v-show="false">
        <week-day-picker :multiple="false" label="Día de programación" :disabled="lock" :value="cronScheduleDay"
                         v-on:change="onWeekDaysChange"/>
      </v-flex>
      <v-flex xs12 v-show="false">
        <v-card color="" height="170" class="pa-1">

          <v-card-title class="pa-1">
            Horas a programar:
            <v-spacer></v-spacer>
            <v-tooltip left>
              <template v-slot:activator="{ on }">
                <v-icon @click="$emit('request-current-events')">fas fa-arrow-circle-down</v-icon>
              </template>
              <span>Cargar horario actual</span>
            </v-tooltip>
          </v-card-title>

          <v-divider class="mt-1"></v-divider>

          <v-card-text class="pa-0">

            <div class="caption text-center pa-2" v-if="cronEvents.length === 0">
              Sin horas para programar.
            </div>

            <v-layout wrap v-else>
              <v-flex xs12>
                <v-layout wrap>
                  <v-flex xs2 v-for="(evts, attr) in formattedEvents" :key="`header-${attr}`">{{ attr }}</v-flex>
                </v-layout>
              </v-flex>
              <v-flex xs12>
                <v-sheet height="100" color="grey lighten-3 pa-1" style="overflow-y: auto">
                  <v-layout wrap>
                    <v-flex xs2 v-for="(evts, attr) in formattedEvents" :key="`events-${attr}`">
                      <v-layout wrap>
                        <v-flex xs12 v-for="(evt, index) in evts" :key="`${attr}-${index}`">{{ evt }}</v-flex>
                      </v-layout>
                    </v-flex>
                  </v-layout>
                </v-sheet>
              </v-flex>

            </v-layout>

          </v-card-text>
        </v-card>
      </v-flex>
    </template>

  </v-layout>
</template>

<script>
import WeekDayPicker from './WeekDayPicker'
import {mapMutations} from 'vuex'

export default {
  props: [
    'autoSchedule',
    'lock',
    'calendarStart',
    'calendarEnd',
  ],
  components: {WeekDayPicker},
  mounted() {
    this.setDefaults()
  },
  methods: {
    ...mapMutations(['showSnackBar']),
    loadNewEvents(evts) {
      var vm = this
      vm.cronEvents = evts
    },
    onWeekDaysChange(val) {
      this.cronScheduleDay = val
    },
    reset() {
      var vm = this
      vm.cronScheduleDay = 0
      vm.cronEvents = []
      vm.cronActive = false
    },
    setDefaults() {
      var vm = this
      vm.cronScheduleDay = vm.autoSchedule && typeof vm.autoSchedule.schedule_day === 'number' ? vm.autoSchedule.schedule_day : 0
      vm.cronEvents = vm.autoSchedule && vm.autoSchedule.events || []
      vm.cronActive = !!(vm.autoSchedule && vm.autoSchedule.active)
    },
    getConfig() {
      var vm = this
      return {
        active: vm.cronActive ? 1 : 0,
        start: vm.calendarStart && vm.$moment(vm.calendarStart).format('YYYY-MM-DD') || null,
        end: vm.calendarEnd && vm.$moment(vm.calendarEnd, 'YYYY-M-D').format('YYYY-MM-DD') || null,
      }
    },
    dayForHumans(number) {
      const days = {
        0: 'Dom',
        1: 'Lun',
        2: 'Mar',
        3: 'Mié',
        4: 'Jue',
        5: 'Vie',
        6: 'Sáb',
      }

      return days[number]

    }
  },
  data(vm) {
    return {
      cronScheduleDay: vm.autoSchedule && typeof vm.autoSchedule.schedule_day === 'number' ? vm.autoSchedule.schedule_day : 0,
      cronEvents: vm.autoSchedule && vm.autoSchedule.events || [],
      cronActive: vm.autoSchedule && vm.autoSchedule.active || false,
      alert: false
    }
  },
  computed: {
    config(){
      var vm = this
      return {
        active: vm.cronActive ? 1 : 0,
        start: vm.calendarStart && vm.$moment(vm.calendarStart).format('YYYY-MM-DD') || null,
        end: vm.calendarEnd && vm.$moment(vm.calendarEnd).format('YYYY-MM-DD') || null,
      }
    },
    isValid() {
      const vm = this
      return (vm.cronActive && vm.calendarStart && vm.calendarEnd) || !vm.cronActive
    },
    formattedEvents() {
      var vm = this
      var days = {};

      const allEvents = vm.cronEvents.sort((a, b) => a.day - b.day)

      for (let i in allEvents) {

        const index = vm.dayForHumans(vm.cronEvents[i].day)
        if (!days[index]) days[index] = []

        days[index].push(
            vm.cronEvents[i].time
        )

        days[index] = days[index].sort((a, b) => vm.$moment(a, 'HH:mm').unix() - vm.$moment(b, 'HH:mm').unix())

      }

      return days

    }
  },
  watch: {
    weekDaysValue(val) {
      var vm = this
      vm.cronScheduleDay = val
    },
    autoSchedule(val) {
      var vm = this
      vm.setDefaults()
    }
  }
}
</script>
